import React from "react";
import { useTranslation } from 'react-i18next';
import { Typography, Button } from "stories/components";
import { Container, Row, Col } from "stories/layout";

const SubscriptionOptionsInfo = ({ handleResolve, handleReject, custom_info_text }) => {
    const { t } = useTranslation();

    return (
    <Container fluid>
      <Row className="justify-content-center">
        <Col lg="8" md="10" className="text-center">
          <Typography variant="h2" className="mb-4">
            {t("subscription_options_title", "Tilausvaihtoehdot")}
                            </Typography>
                                
          <Typography variant="medium" className="mb-4">
            {custom_info_text || t("subscription_options_default_text", "Valitse sopiva tilauspaketti tarpeidesi mukaan.")}
                            </Typography>
          
          <div className="d-flex justify-content-center gap-3">
            <Button variant="secondary" onClick={handleResolve}>
              {t("continue", "Jatka")}
            </Button>
            <Button variant="light" onClick={handleReject}>
              {t("cancel", "Peruuta")}
                            </Button>
                    </div>
                  </Col>
                </Row>
    </Container>
  );
};

export default SubscriptionOptionsInfo;
